import { CACHING_TIME } from '@/store/utils';
import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import {
  NfmsFilterData,
  NfmsFilterDataWithOptions
} from '../../types/records/main';

export const generalEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'nfmsApi'
  >
) => ({
  getNfmsFilterData: builder.query<
    NfmsFilterDataWithOptions,
    { param: string }
  >({
    query: ({ param }) => ({
      url: `dashboard_apis/${param}/filters`,
      method: 'GET'
    }),
    extraOptions: { maxRetries: 3 },
    providesTags: [],
    keepUnusedDataFor: CACHING_TIME,
    transformResponse: (
      response: NfmsFilterData
    ): NfmsFilterDataWithOptions => {
      return response.map(({ values, ...rest }) => {
        return {
          ...rest,
          options: values.map((item) => ({
            label: item.toString(),
            value: typeof item === 'boolean' ? item : item.toString() //backend does not accept boolean values converted in string.
          }))
        };
      });
    }
  })
});
